import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
  ResponsiveContainer,
} from 'recharts';
import { ChartContainer, ChartConfig } from '@/components/ui/chart';

const chartConfig: ChartConfig = {
  delivered: { label: 'الرحلات المكتملة', color: 'hsl(217, 91%, 60%)' },
};

interface Props {
  data: { driver_name: string; delivered: number; success_rate: number }[];
}

export function DriverRankingChart({ data }: Props) {
  if (!data.length) {
    return (
      <div className="flex items-center justify-center h-[220px] text-muted-foreground text-sm">
        لا توجد بيانات
      </div>
    );
  }

  return (
    <ChartContainer config={chartConfig} className="h-[220px] w-full">
      <BarChart
        layout="vertical"
        data={data}
        margin={{ top: 4, right: 40, left: 8, bottom: 0 }}
      >
        <CartesianGrid strokeDasharray="3 3" horizontal={false} className="stroke-border/40" />
        <XAxis type="number" tick={{ fontSize: 11 }} />
        <YAxis dataKey="driver_name" type="category" width={90} tick={{ fontSize: 10 }} />
        <Tooltip
          contentStyle={{ background: 'hsl(var(--background))', border: '1px solid hsl(var(--border))', borderRadius: 8, fontSize: 12 }}
          formatter={(v: any, name: string) => [v, name === 'delivered' ? 'رحلة مكتملة' : name]}
        />
        <Bar dataKey="delivered" radius={[0, 4, 4, 0]}>
          {data.map((_, i) => (
            <Cell
              key={i}
              fill={`hsl(${217 - i * 10}, 91%, ${60 - i * 3}%)`}
            />
          ))}
        </Bar>
      </BarChart>
    </ChartContainer>
  );
}
